import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }

  connect() {
    if (this.hasContentValue) {
      this.element.setAttribute("title", this.contentValue)
    }
  }
}